import { render, staticRenderFns } from "./mallFooter.vue?vue&type=template&id=4102c00e&scoped=true&"
import script from "./mallFooter.vue?vue&type=script&lang=js&"
export * from "./mallFooter.vue?vue&type=script&lang=js&"
import style0 from "./mallFooter.vue?vue&type=style&index=0&id=4102c00e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4102c00e",
  null
  
)

export default component.exports